// extracted by mini-css-extract-plugin
export var bubble = "_2n-0";
export var container = "_2n-f";
export var contrastBorder = "_2n-g";
export var greyOut = "_2n-2";
export var initialsColor0 = "_2n-3";
export var initialsColor1 = "_2n-4";
export var initialsColor10 = "_2n-d";
export var initialsColor11 = "_2n-e";
export var initialsColor2 = "_2n-5";
export var initialsColor3 = "_2n-6";
export var initialsColor4 = "_2n-7";
export var initialsColor5 = "_2n-8";
export var initialsColor6 = "_2n-9";
export var initialsColor7 = "_2n-a";
export var initialsColor8 = "_2n-b";
export var initialsColor9 = "_2n-c";
export var initialsWrapper = "_2n-1";
export var large = "_2n-l";
export var medium = "_2n-k";
export var mediumSmall = "_2n-j";
export var mediumSmallMedium = "_2n-o";
export var micro = "_2n-h";
export var small = "_2n-i";
export var tiny = "_2n-n";
export var xTiny = "_2n-m";